import React from "react";
import * as Sentry from "@sentry/react";

/**
 * Root-level ErrorBoundary wrapper.
 * Uses Sentry.ErrorBoundary when Sentry is loaded; falls back to a plain
 * error message when any React render error occurs.
 */
const ErrorFallback: React.FC = () => (
  <div
    style={{
      padding: "40px 24px",
      maxWidth: 560,
      margin: "80px auto",
      textAlign: "center",
      fontFamily: "system-ui, sans-serif",
    }}
  >
    <h2 style={{ color: "#333", marginBottom: 12 }}>Oups, une erreur est survenue</h2>
    <p style={{ color: "#666", marginBottom: 24 }}>
      Nous avons été informés du problème. Veuillez rafraîchir la page.
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      style={{
        padding: "10px 24px",
        background: "#E6C3B5",
        border: "none",
        borderRadius: 4,
        cursor: "pointer",
        fontSize: 14,
      }}
    >
      Rafraîchir
    </button>
  </div>
);

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => (
  <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
    {children}
  </Sentry.ErrorBoundary>
);

export default ErrorBoundary;
